<template>
  <BaseModal>
    <div class="auth-modal-wrapper">
      <h4
        class="auth-modal-header c-red"
        v-if="!twofactor_enabled"
      >
        {{ $t('settings.two_factor.is_disabled') }}
      </h4>
      <h4
        class="auth-modal-header c-green"
        v-if="twofactor_enabled"
      >{{ $t('settings.two_factor.is_enabled') }}</h4>
      <p class="comment c-grey" v-if="!change_token">
          {{ $t('settings.two_factor.enter_phone') }}
      </p>
      <p class="comment c-grey" v-if="change_token">
          {{ $t('settings.two_factor.sms_sent', {phone}) }}
      </p>
      <BaseInput 
        class="phone-input"  
        v-model="phone" 
        :mask="'+38-###-###-##-##'"
        placeholder="+38-XXX-XXX-XX-XX"
        :readonly="twofactor_enabled"
        v-if="!change_token"/>
        <BaseInput 
        :class="{
            'phone-input': true,
            'red-input': !!error
        }"  
        v-model="confirm_code" 
        :mask="'######'"
        :placeholder="$t('settings.two_factor.confirm_code_ph')"
        :readonly="false"
        v-if="change_token"/>
      <div class="auth-modal-buttons">
        <button class="round-button round-button-green" v-if="!twofactor_enabled && !change_token" @click="saveSettings">
            {{ $t('settings.two_factor.enable') }}
        </button>
        <button class="round-button round-button-red" v-if="twofactor_enabled && !change_token" @click="saveSettings">
            {{ $t('settings.two_factor.disable') }}
        </button>
         <button class="round-button round-button-green" v-if="change_token" @click="saveSettings">
            {{ $t('settings.two_factor.confirm') }}
        </button>
        <button class="round-button last-button" @click="onCancel">
          {{ $t('settings.two_factor.cancel') }}
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";
import BlackInput from "@/components/BlackInput.vue"

import AuthAPI from "@/api/auth";

export default {
  components: {
    BaseModal,
    BlackInput
  },
  data() {
      return {
          phone: null,

          change_token: null,
          confirm_code: null,

          error: null
      }
  },
  methods: {
    requestToken() {
        if (!this.phone || this.phone.length < 17) {
            return;
        }

        const raw_phone = this.phone.split('-').join('');

        AuthAPI.changeTwoFactorAuth(!this.twofactor_enabled, raw_phone).then(data => {
            this.change_token = data.token;
            this.confirm_code = null;
        }).catch(error => {
            this.$store.dispatch('showError', 'auth_error')
        });
    },
    tryToConfirm() {
        if (!this.confirm_code) return;

        AuthAPI.confirmTwoFactorAuthChange(this.change_token, this.confirm_code).then(data => {
            this.$store.commit('setOwnerTwoFactorAuth', !this.twofactor_enabled)
            this.$emit('success', !this.twofactor_enabled);
            this.$emit('close');
        }).catch(error => {
            this.error = error;
            this.confirm_code = null;
        });
    },  
    saveSettings() {
        if (!this.change_token) {
            this.requestToken();
        } else {
            this.tryToConfirm();
        }
    },
    onCancel() {
      this.$emit("close");
    }
  },
  mounted() {
    if (this.owner.two_factor_auth.phone) {
      this.phone =  this.owner.two_factor_auth.phone;
    }
  },
  computed: {
    owner() {
      return this.$store.state.owner;
    },
    twofactor_enabled() {
      return this.owner.two_factor_auth.enabled;
    }
  }
};
</script>

<style scoped>
.auth-password-input {
  width: 100%;
}

.auth-modal-buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;
}

.auth-error {
  color: #e2223b;
  margin-top: 1vh;
  text-align: center;
}

.auth-confirm-button {
  width: 25vh;
}

.phone-input {
    margin-top: 1vh;
    width: 100%;
}

.red-input {
    border: 2px solid #e2223b;
}
</style>